import FlightMatrixApiUrls from 'src/apiUrls/FlightMatrixApiUrls'
import FormProperties from './FormProperties'
import { Box, Card, Grid } from '@material-ui/core'
import React, { useEffect, useState} from 'react'
import { components } from 'cng-web-lib'
import pathMap from 'src/paths/pathMap'
import { useFormContext } from 'react-hook-form'
import withFormState from '../../../components/aciacehighway/hocs/withFormState'
import AlertDialog from '../../../components/aciacehighway/AlertDialog'

const {
  button: { CngButton },
  form: { CngAddForm }
} = components

function AddPage(props) {
  const { history, onSetLoading, showNotification } = props

  return (
    <Card>
      <Box p={2}>
        <CngAddForm
          fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
          history={history}
          showNotification={showNotification}
          formikProps={FormProperties.formikProps}
          renderBodySection={(labelMap, shouldHideMap) => (
            <FormProperties.Fields
              showNotification={showNotification}
              shouldHideMap={shouldHideMap}
            />
          )}
          toClientDataFormat={FormProperties.toClientDataFormat}
          toServerDataFormat={FormProperties.toServerDataFormat}
          create={{
            url: FlightMatrixApiUrls.POST,
            successRedirect: pathMap.FLIGHT_MATRIX_LIST_VIEW
          }}
          renderButtonSection={() => (
            <ButtonSection
              onSetLoading={onSetLoading}
              onDiscard={() => history.push(pathMap.FLIGHT_MATRIX_LIST_VIEW)}
            />
          )}
        />
      </Box>
    </Card>
  )
}

function ButtonSection(props) {
  const { onSetLoading, onDiscard } = props

  const [confirmDialog, setConfirmDialog] = useState(false)
  const {
    formState: { isSubmitting }
  } = useFormContext()

  useEffect(() => {
    onSetLoading(isSubmitting)
  }, [isSubmitting])

  return (
    <>
      <Grid container justify='space-between' spacing={3}>
        <Grid item xs='auto'>
          <CngButton
            color='secondary'
            disabled={isSubmitting}
            onClick={() => setConfirmDialog(true)}
            size='medium'
          >
            Discard
          </CngButton>
        </Grid>
        <Grid item xs='auto'>
          <CngButton
            color='primary'
            disabled={isSubmitting}
            type='submit'
            size='medium'
          >
            Save
          </CngButton>
        </Grid>
      </Grid>
      <AlertDialog
        cancelLabel='Continue editing'
        confirmLabel='Yes, discard'
        open={confirmDialog}
        onClose={() => setConfirmDialog(false)}
        onCancel={() => setConfirmDialog(false)}
        onConfirm={onDiscard}
        title='Discard'
      >
        All progress in this session will be lost and cant't be restored. Are
        you sure about this?
      </AlertDialog>
    </>
  )
}

export default withFormState(AddPage)
